import { render, staticRenderFns } from "./housingSelling.vue?vue&type=template&id=fb2eade2&scoped=true&"
import script from "./housingSelling.vue?vue&type=script&lang=js&"
export * from "./housingSelling.vue?vue&type=script&lang=js&"
import style0 from "./housingSelling.vue?vue&type=style&index=0&id=fb2eade2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2eade2",
  null
  
)

export default component.exports